import React, { useState, useEffect } from "react"
import { cn } from "lib/utils"

const grids = [
  { 
    id: "grid-1",
    name: "Image Grid 1",
    config: [
      {
        column: "col1",
        width: 8,
        containers: [ { id: "col1-A", contains: {} } ]
      },
      {
        column: "col2",
        width: 4,
        containers: [ 
          { id: "col2-A", contains: {} }, 
          { id: "col2-B", contains: {} } 
        ]
      }
    ]
  }
]


function ImageGrid({ configData }:{ configData?:any }){
  const [ config, setConfig ] = useState<any>(configData) 

  return (
    <div className="w-full min-h-[24rem] flex justify-start items-stretch border border-dotted border-neutral-400">
      { config.map( (col:any) => (
        <div 
          className={cn(
            "min-h-[24rem] flex flex-col border border-dotted border-neutral-400 relative",
            col.width === 2 && "w-2/12",
            col.width === 3 && "w-3/12",
            col.width === 4 && "w-4/12",
            col.width === 5 && "w-5/12",
            col.width === 6 && "w-6/12",
            col.width === 7 && "w-7/12",
            col.width === 8 && "w-8/12",
            col.width === 9 && "w-9/12",
            col.width === 10 && "w-10/12",
            col.width === 11 && "w-11/12",
            col.width === 12 && "w-12/12",
          )}
        >
          { col.containers.map( (container:any) => (
            <div 
              key={container.id}
              onDrop={(e:any) => {
                e.preventDefault()
                const data = e.dataTransfer.getData("text/plain")
                const img = JSON.parse(data)
                const newConfig = config.map( (column:any) => {
                  if( column.id !== col.id ) return column
                  return {
                    ...column,
                    containers: column.containers.map( (c:any) => {
                      if( c.id !== container.id ) return c
                      return { ...c,  contains: { ...c.contains, img: img } }
                    })
                  }
                })
                setConfig(newConfig)
              }}
              onDragOver={(e:any) => {
                e.preventDefault()
              }}
              className={cn(
                "flex justify-center items-center",
                col.containers.length === 1 && "min-h-[100%]",
                col.containers.length === 2 && "min-h-[50%]",
                col.containers.length === 3 && "min-h-[33.33%]",
                col.containers.length === 4 && "min-h-[25%]",
                // container.contains.img === undefined && "absolute top-0 left-0 right-0 bottom-0 m-auto w-[80px] h-[80px] bg-green-500"
              )}
            >
              { container.contains.img ? (
                <img src={ container.contains.img.src } alt={ container.contains.img.title } />
              ): (
                <span>{ container.id }</span>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}


function GridPreviewArea(){

  const [ currentGridIdx, setCurrentGridIdx ] = useState<number>(0)


  return (
    <div className="w-full min-h-[16rem] bg-neutral-300 border border-dashed border-neutral-400 p-3 flex justify-center items-start">
      <ImageGrid configData={grids[currentGridIdx].config} />
    </div>
  )
}


const images = [
  {
    id: "7gushcusgcysgce",
    src: "https://woopla.midmetrics.io/api/representment/GetRepresentmentImageSec?guid=263c9125-2293-46ca-ac68-51a1086bbd1d",
    title: "Image 1",
    caption: "This is the first image"
  },
  {
    id: "68h8u23d6fwd6guwecwe",
    src: "https://woopla.midmetrics.io/api/representment/GetRepresentmentImageSec?guid=d3ff5f7a-2558-4be8-aeb0-f9d55772e626",
    title: "Image 2",
    caption: "This is the second image"
  },
  {
    id: "9h7fd6fgd6wdfc6wdfefce",
    src: "https://woopla.midmetrics.io/api/representment/GetRepresentmentImageSec?guid=ef53b43e-2790-47dc-966d-6b911553aa6c",
    title: "Image 3",
    caption: "This is the third image"
  },
  {
    id: "23er3frfrvrhvrtuhbvtb",
    src: "https://woopla.midmetrics.io/api/representment/GetRepresentmentImageSec?guid=8671b27b-46ce-40df-9777-d8f23c0073ae",
    title: "Image 4",
    caption: "This is the fourth image"
  }
]

export default function ImageManager(){


  const [ imageDisplay, setImageDisplay ] = useState<any[]>([
    {
      row: 1, 
      columns: [

      ]
    }
  ])


  return (
    <div className="w-full flex flex-col justify-center border border-solid border-neutral-700 gap-6 my-8 px-2 py-6">

      <div className="w-full flex justify-start items-center border border-solid border-neutral-700 min-h-20">
        <GridPreviewArea />
      </div>


      <div className="w-full flex flex-wrap justify-center gap-x-4 gap-y-2 py-4">
        { images.map( (img:any) => (
          <div 
            key={img.id} 
            draggable={true}
            onDragStart={(e:any) => {
              e.dataTransfer.setData("text/plain", JSON.stringify(img))
            }}
            className="w-[6rem] h-[4rem]"
            style={{
              backgroundImage: `url(${img.src})`, 
              backgroundSize: "contain", 
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat"
            }}  
          />
        ))}
      </div>


    </div>
  )


}